import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription, Subject } from "rxjs";
import { UserService } from "../../services/user.service";

@Component({
    selector: "app-user-list",
    templateUrl: "./user-list.component.html",
    styleUrls: ["./user-list.component.scss"],
})
export class UserListComponent implements OnInit, OnDestroy {
    initialSearchPerformed: boolean = false;
    isSearching: boolean = false;
    results: any[] = [];
    searchTerm: string;
    page: number = 1;
    pageSize: number = 10;
    totalPages: number = 1;    
    searchTypeSelection: string = "email"; // "email" or "lastname"

    @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
    @ViewChild("searchType", { static: true }) searchType: ElementRef;

    searchSubscription: Subscription = new Subscription();
    subscriptions: Subscription[] = [];

    constructor(
        private userService: UserService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        this.subscriptions.push(
            this.route.queryParams.subscribe((params) => {
                if (!this.initialSearchPerformed) {
                    this.searchTerm = params["searchTerm"] || "";
                    this.searchTypeSelection = params["searchType"] || "email";
                    this.page = 1;
                    this.pageSize = 10;
                    this.searchInput.nativeElement.value = this.searchTerm;
                    this.searchType.nativeElement.value = this.searchTypeSelection;
                    this.initialSearchPerformed = true;
                    this.search();
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }

    pageSelected(page: number) {
        this.page = page;
        this.search();
      }

    searchUpdated(value: string) {
        this.searchTerm = value;
        this.page = 1;
    }

    updateSearchType(value: any) {
        this.searchTypeSelection = value;
        this.page = 1;
    }

    search() {
        this.isSearching = true;

        this.searchSubscription.unsubscribe();

        this.searchSubscription = this.userService
            .search(this.searchTerm, this.searchTypeSelection, this.page, this.pageSize)
            .subscribe((res) => {
                var result = res as any;
                this.results = result.items;
                this.page = result.currentPage;
                this.pageSize = result.pageSize;
                this.totalPages = result.totalPages;
                this.isSearching = false;

                var queryParams = {};                
                queryParams["searchTerm"] = this.searchTerm ?? "";
                queryParams["searchType"] = this.searchTypeSelection ?? "";
                queryParams["page"] = this.page ?? "";
                queryParams["pageSize"] = this.pageSize ?? "";
                
                this.router.navigate(["/portal/admin/users"], {
                    queryParams: queryParams,
                    replaceUrl: true,
                });
            });
    }
}
